<div
  class="chitinSelect"
  ngbDropdown
  #selectDropdown="ngbDropdown"
  [dropdownClass]="dropdownClass() ?? ''"
  [container]="appendTo() === 'parent' ? null : 'body'"
>
  <input
    class="form-control"
    [class.isLoading]="isLoading()"
    [ngClass]="inputClassCombined()"
    [class.disabled]="isLoading() || disabled()"
    [class.has-value]="value() !== undefined && value() !== ''"
    [placeholder]="isLoading() ? '' : displayText"
    [disabled]="isLoading() || disabled()"
    [readonly]="!searchable()"
    [(ngModel)]="searchTerm"
    (ngModelChange)="onSearchTermChanged($event)"
    ngbDropdownAnchor
    (click)="selectDropdown.toggle()"
    (keyup.enter)="selectDropdown.toggle()"
  />
  @if (isLoading()) {
    <app-loading-spinner borderStyle="width: 1rem; height: 1rem" [isLoading]="true" />
  }
  <div style="max-height: 300px; overflow-y: auto" ngbDropdownMenu>
    @if (groupItems()) {
      @for (group of groupedItems | keyvalue; track group) {
        <button class="dropdown-group" [ngClass]="{ active: group.value.selected }" (click)="group.value.open = !group.value.open">
          <span class="me-2">{{ group.key }}</span>
          <span style="font-size: 80%">
            <chitin-icon [icon]="group.value.open ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'" />
          </span>
        </button>
        @if (group.value.open) {
          @for (option of group.value.items; track option) {
            <button
              [ngClass]="{ active: option.value === value() || (!!value() && $any(value()).includes(option)) }"
              data-testid="chitinSelectOption"
              ngbDropdownItem
              style="padding-inline-start: 2rem !important"
              (click)="selectItem(option)"
            >
              {{ option.name }}
            </button>
          }
        }
      }
    } @else {
      @for (option of visibleOptions; track option) {
        <button
          [ngClass]="{ active: selectedItems.includes(option) }"
          data-testid="chitinSelectOption"
          ngbDropdownItem
          (click)="selectItem(option)"
        >
          {{ option.name }}
        </button>
      }
    }
  </div>
</div>
